import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async save(brandZones) {
        return await http.put(buildUrlFromLocation("/admin/brand-has-zones"), brandZones);
    },
    async copyTo(copyTo, brandZones) {
        return await http.put(buildUrlFromLocation(`/admin/brand-has-zones/copy-to/${copyTo}`), brandZones);
    }
};



// WEBPACK FOOTER //
// ./src/services/brandHasZones.js